export default __webpack_public_path__ + "static/media/photo2.00fc7e28.jpg";